import { Typography } from '@material-tailwind/react';
import { Menu } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { changeNavBar } from '../slices/menubarSlice';

const Title = ({ children }) => {
  const { statusBar } = useSelector((state) => state.navBar);
  const dispatch = useDispatch();
  const handleMenu = () => {
    dispatch(changeNavBar());
  };
  return (
    <div className="flex sm:items-center">
      {!statusBar && (
        <Menu
          onClick={handleMenu}
          className="mt-1 sm:mb-5 cursor-pointer rounded-sm w-10 h-10 z-50  text-white "
        />
      )}
      <Typography
        variant="h3"
        className="mt-1 sm:mb-5  text-white w-full sm:text-nowrap text-center sm:text-start"
      >
        {children}
      </Typography>
    </div>
  );
};

export default Title;
